import {
  Utensils,
  Briefcase,
  Building,
  Plus,
  FileText,
  Users,
  Bus,
  Train,
  Plane,
  Car,
  Mountain,
  Shield,
  Coffee,
  Wifi,
  Tent,
  MapPin,
  Circle,
  Snowflake,
  Sun,
  Moon,
  Cloud,
  CloudRain,
  Wind,
  TreePine,
  Leaf,
  Compass,
  Navigation,
  Anchor,
  Camera,
  Video,
  Music,
  Ticket,
  Landmark,
  Hospital,
  Pill,
  Zap,
  Flame,
  Droplets,
  Backpack,
  Award,
  Flag,
  Globe2,
  Bike,
  Footprints,
  Heart,
  Star,
  Sparkles,
  Phone,
  Mail,
  Calendar,
  Clock,
  CreditCard,
  Banknote,
  Home,
  BedDouble,
  MapPinned,
  Route,
  Binoculars,
  Shirt,
  ThermometerSun,
  Wine,
  IceCream,
  Dog,
  Fish,
  Sailboat,
  TrainFront,
  Luggage,
  CircleCheck,
  Check,
  Headphones,
  Info,
  HelpCircle,
  Activity
} from 'lucide-react';

/** Slug → emoji (legacy + Home “Choose Your Experience” parity). Raw emoji in DB skips this. */
export const INCLUDE_SLUG_TO_EMOJI = {
  snow: '❄️',
  car: '🚗',
  mountain: '🏔️',
  camp: '🏕️',
  cycle: '🚴‍♂️'
};

/** Map admin "icon" string (lowercase slug) → Lucide component */
const FEE_INCLUDE_ICON_MAP = {
  check: Check,
  utensils: Utensils,
  food: Utensils,
  briefcase: Briefcase,
  travelling: Briefcase,
  traveling: Briefcase,
  travel: Briefcase,
  suitcase: Briefcase,
  building: Building,
  accommodation: Building,
  hotel: Building,
  stay: Building,
  plus: Plus,
  'first-aid': Plus,
  firstaid: Plus,
  medical: Plus,
  'file-text': FileText,
  filetext: FileText,
  gst: FileText,
  document: FileText,
  invoice: FileText,
  users: Users,
  instructors: Users,
  people: Users,
  team: Users,
  bus: Bus,
  train: Train,
  plane: Plane,
  flight: Plane,
  car: Car,
  mountain: Mountain,
  trek: Mountain,
  shield: Shield,
  insurance: Shield,
  coffee: Coffee,
  wifi: Wifi,
  tent: Tent,
  camp: Tent,
  map: MapPin,
  mappin: MapPin,
  location: MapPin,
  'map-pin': MapPin,
  mappinned: MapPinned,
  snowflake: Snowflake,
  sun: Sun,
  moon: Moon,
  cloud: Cloud,
  'cloud-rain': CloudRain,
  cloudrain: CloudRain,
  wind: Wind,
  'tree-pine': TreePine,
  treepine: TreePine,
  leaf: Leaf,
  compass: Compass,
  navigation: Navigation,
  anchor: Anchor,
  camera: Camera,
  video: Video,
  music: Music,
  ticket: Ticket,
  landmark: Landmark,
  hospital: Hospital,
  pill: Pill,
  zap: Zap,
  flame: Flame,
  droplets: Droplets,
  backpack: Backpack,
  award: Award,
  flag: Flag,
  globe: Globe2,
  globe2: Globe2,
  bike: Bike,
  footprints: Footprints,
  heart: Heart,
  star: Star,
  sparkles: Sparkles,
  phone: Phone,
  mail: Mail,
  calendar: Calendar,
  clock: Clock,
  'credit-card': CreditCard,
  creditcard: CreditCard,
  banknote: Banknote,
  home: Home,
  bed: BedDouble,
  beddouble: BedDouble,
  route: Route,
  binoculars: Binoculars,
  shirt: Shirt,
  'thermometer-sun': ThermometerSun,
  thermometersun: ThermometerSun,
  wine: Wine,
  'ice-cream': IceCream,
  icecream: IceCream,
  dog: Dog,
  fish: Fish,
  sailboat: Sailboat,
  'train-front': TrainFront,
  trainfront: TrainFront,
  luggage: Luggage,
  'circle-check': CircleCheck,
  circlecheck: CircleCheck,
  headphones: Headphones,
  info: Info,
  'help-circle': HelpCircle,
  helpcircle: HelpCircle,
  circle: Circle,
  activity: Activity,
  distance: Activity,
  km: Activity,
  snow: Snowflake,
  winter: Snowflake,
  'winter-special': Snowflake,
  altitude: Mountain,
  'high-altitude': Mountain,
  age: Users,
  'group-size': Users,
  group: Bus,
  'group-trip': Bus,
  things: Briefcase,
  cancellation: Clock,
  terms: Shield
};

function normalizeFeeIncludeIconKey(icon) {
  if (icon == null || icon === '') return '';
  return String(icon).trim().toLowerCase().replace(/\s+/g, '-');
}

export function getFeeIncludeIconComponent(icon) {
  const k = normalizeFeeIncludeIconKey(icon);
  return FEE_INCLUDE_ICON_MAP[k] || Circle;
}

/**
 * Package “Includes” sidebar only: never fall back to empty `Circle` ring — use Briefcase
 * when slug is missing or not in the map (typos / old data).
 */
export function getIncludeSidebarLucideComponent(icon) {
  const k = normalizeFeeIncludeIconKey(icon);
  if (!k) return Briefcase;
  return FEE_INCLUDE_ICON_MAP[k] || Briefcase;
}

/** Sorted slug list for admin dropdowns */
export const LUCIDE_INCLUDE_ICON_SLUGS = Object.keys(FEE_INCLUDE_ICON_MAP).sort((a, b) =>
  a.localeCompare(b)
);

/**
 * @returns {{ mode: 'emoji', text: string } | { mode: 'lucide', slug: string }}
 */
export function getIncludeIconDisplay(raw) {
  const s = String(raw ?? '').trim();
  if (!s) return { mode: 'lucide', slug: '' };
  const slug = normalizeFeeIncludeIconKey(s);
  if (INCLUDE_SLUG_TO_EMOJI[slug]) {
    return { mode: 'emoji', text: INCLUDE_SLUG_TO_EMOJI[slug] };
  }
  try {
    if (/\p{Extended_Pictographic}/u.test(s)) {
      return { mode: 'emoji', text: s };
    }
  } catch {
    // ignore
  }
  return { mode: 'lucide', slug: s };
}
